import React from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { SalesLetter } from './components/SalesLetter';
import { FeaturesSection } from './components/FeaturesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { DetailedSection } from './components/DetailedSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencyClose } from './components/UrgencyClose';
import { FaqSection } from './components/FaqSection';
import { FinalRecap } from './components/FinalRecap';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full font-serif text-body-text leading-relaxed" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <main data-id="element-3">
        <SalesLetter data-id="element-4" />
        <FeaturesSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <DetailedSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <UrgencyClose data-id="element-11" />
        <FaqSection data-id="element-12" />
        <FinalRecap data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}